module.exports = __webpack_public_path__ + "static/media/FFEP_230622.e4e963ad.jpg";